import { render } from "./SkippersForm.vue?vue&type=template&id=256c30e4&scoped=true"
import script from "./SkippersForm.vue?vue&type=script&lang=js"
export * from "./SkippersForm.vue?vue&type=script&lang=js"

import "./SkippersForm.vue?vue&type=style&index=0&id=256c30e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-256c30e4"

export default script